import React, { useContext, useRef, useEffect } from "react"
import { AppContext } from "../App"
import { LetterStatus } from "../helpers"
import strings from "../strings"

type Props = {
  keyVal: string
  bigKey?: boolean
  status?: LetterStatus
  pulseTrigger?: number
}

function Key({ keyVal, bigKey, status, pulseTrigger }: Props) {
  const { onDelete, onEnter, onSelectLetter } = useContext(AppContext)
  const keyRef = useRef<HTMLDivElement>(null)

  // Trigger pulse animation when pulseTrigger changes (for keyboard events)
  useEffect(() => {
    if (pulseTrigger && keyRef.current) {
      keyRef.current.classList.remove('pulse')
      // Force reflow to restart animation
      void keyRef.current.offsetHeight
      keyRef.current.classList.add('pulse')
      
      // Remove class after animation
      setTimeout(() => {
        if (keyRef.current) {
          keyRef.current.classList.remove('pulse')
        }
      }, 200)
    }
  }, [pulseTrigger])

  const selectLetter = () => {
    // Add pulse effect
    if (keyRef.current) {
      keyRef.current.classList.remove('pulse')
      // Force reflow to restart animation
      void keyRef.current.offsetHeight
      keyRef.current.classList.add('pulse')
      
      // Remove class after animation
      setTimeout(() => {
        if (keyRef.current) {
          keyRef.current.classList.remove('pulse')
        }
      }, 100)
    }

    if (keyVal === "VEE UIT") {
      onDelete()
    } else if (keyVal === "VOER IN") {
      onEnter()
    } else {
      onSelectLetter(keyVal)
    }
  }

  let letterState = ""
  switch (status) {
    case LetterStatus.Letter:
      letterState = "almost"
      break
    case LetterStatus.LetterAndPosition:
      letterState = "correct"
      break
    case LetterStatus.Disabled:
      letterState = "error"
      break
    default:
      break
  }

  // Helper function to render key content with icons
  const renderKeyContent = () => {
    // Check if this is the enter key - show only icon
    if (keyVal === strings.enter) {
      return <span className="key-icon enter-icon">↵</span>
    }
    
    // Check if this is the delete/backspace key - show only icon
    if (keyVal === strings.delete) {
      return <span className="key-icon backspace-icon">⌫</span>
    }
    
    // Regular key - just return the text
    return keyVal
  }

  return (
    <div
      ref={keyRef}
      className="key"
      id={bigKey ? "big" : letterState}
      onClick={selectLetter}
    >
      {renderKeyContent()}
    </div>
  )
}

export default Key
